function nationalDigits(value) {
  const digits = String(value ?? "").replace(/\D/g, "");
  if (digits.length === 11 && digits.startsWith("1")) return digits.slice(1);
  return digits;
}

/** Mask while typing. A full US number becomes (xxx) xxx-xxxx. */
export function formatPhone(value) {
  const digits = nationalDigits(value).slice(0, 10);
  if (!digits) return "";
  if (digits.length < 4) return `(${digits}`;
  if (digits.length < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}

/** Read-only display. Non-US values stay as entered. */
export function formatPhoneDisplay(value) {
  if (value == null) return "";
  const raw = String(value).trim();
  if (!raw) return "";
  const digits = nationalDigits(raw);
  if (digits.length !== 10) return raw;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}
